import { useEffect, useRef, useState } from 'react'

function pct(n, total) {
  if (!total) return 0
  return Math.round((n / total) * 1000) / 10  // one decimal place
}

export function VoteBar({
  label,
  optionKey,
  variant = 'yes',         // 'yes' | 'no' | 'unsure' | 'candidate'
  residentCount = 0,
  nonResidentCount = 0,
  totalAllOptions,         // sum across every option, used for bar widths
  voted = false,
  disabled = false,
  onVote,
}) {
  // UX37: when `voted` flips false → true, pulse the row briefly. The
  // bar widths animate on their own via CSS transition on .bar-segment;
  // this just adds a short glow class to the matching row so the user
  // sees the cause-and-effect clearly.
  const prevVoted = useRef(voted)
  const [justVoted, setJustVoted] = useState(false)
  useEffect(() => {
    if (voted && !prevVoted.current) {
      setJustVoted(true)
      const t = setTimeout(() => setJustVoted(false), 900)
      return () => clearTimeout(t)
    }
    prevVoted.current = voted
  }, [voted])
  const total = residentCount + nonResidentCount
  const residentWidth = totalAllOptions
    ? (residentCount / totalAllOptions) * 100
    : 0
  const nonResidentWidth = totalAllOptions
    ? (nonResidentCount / totalAllOptions) * 100
    : 0

  const residentPctOfChoice = pct(residentCount, total)
  const nonResidentPctOfChoice = pct(nonResidentCount, total)

  const colorVar =
    variant === 'yes'    ? 'var(--yes-bar)' :
    variant === 'no'     ? 'var(--no-bar)' :
    variant === 'unsure' ? 'var(--unsure-bar)' :
    'var(--granite)'

  const nrColorVar =
    variant === 'yes'    ? 'var(--yes-nr-bar)' :
    variant === 'no'     ? 'var(--no-nr-bar)' :
    variant === 'unsure' ? '#C0B5A0' :
    'var(--dusk)'

  return (
    <div className={`vote-row ${justVoted ? 'just-voted' : ''}`}>
      <button
        type="button"
        className={`vote-btn ${variant} ${voted ? 'voted' : ''}`}
        onClick={() => onVote?.(optionKey || label)}
        aria-disabled={disabled || undefined}
        aria-pressed={voted}
      >
        {label}
      </button>

      <div className="bar-wrap">
        <div className="bar-track" role="img" aria-label={`${label}: ${total} votes`}>
          <span
            className="bar-segment"
            style={{ width: `${residentWidth}%`, background: colorVar }}
          />
          <span
            className="bar-segment"
            style={{ width: `${nonResidentWidth}%`, background: nrColorVar }}
          />
        </div>
        {totalAllOptions > 0 && (
          <div className="bar-labels">
            <span><strong>{residentPctOfChoice}%</strong> resident</span>
            <span><strong>{nonResidentPctOfChoice}%</strong> non-resident</span>
          </div>
        )}
      </div>

      <span className="vote-count">{total}</span>
    </div>
  )
}
